<template>
  <section class="monthly u-margin-big-top-bottom" id="sectionmonthly">
    <div class>
      <h1
        class="next-week-heading header-primary--sub u-text-center u-uppercase u-margin-big-bottom"
      >
        Monthly calender
      </h1>
    </div>
    <div class="monthly-container">
      <MonthlyCard :months="winter" />
      <MonthlyCard :months="spring" />
      <MonthlyCard :months="summer" />
      <MonthlyCard :months="autumn" />
    </div>
  </section>
</template>
<script>
import MonthlyCard from "./MonthlyCard";
export default {
  props: ["monthly"],
  data() {
    return {
      winter: [],
      spring: [],
      summer: [],
      autumn: [],
    };
  },
  methods: {
    zeroPadding(value) {
      return value < 10 ? "0" + value : value;
    },
  },
  created() {
    for (let i = 0; i < this.monthly.length; i++) {
      switch (i) {
        case 0:
        case 1:
        case 2:
          this.winter.push(this.monthly[i]);
          break;
        case 3:
        case 4:
        case 5:
          this.spring.push(this.monthly[i]);
          break;
        case 6:
        case 7:
        case 8:
          this.summer.push(this.monthly[i]);
          break;
        case 9:
        case 10:
        case 11:
          this.autumn.push(this.monthly[i]);
          break;
      }
    }
  },
  components: {
    MonthlyCard,
  },
};
</script>
